import { Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import { useSnackbar } from "notistack";
import React from "react";
import {
	GoogleLogin,
	GoogleLoginResponse,
	GoogleLoginResponseOffline,
} from "react-google-login";

import { useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import SignInInputBox from "./SignInInputBox";
import GoogleLogo from "@/assets/ic_google.svg";
import Button from "@/components/Button";
import { login } from "@/redux/slices/auth";
import "./index.css";
import { useTranslation } from "react-i18next";

export default function SignInInputComponent() {
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();
	const history = useHistory();
	const dispatch = useDispatch();
	const responseGoogle = (
		response: GoogleLoginResponse | GoogleLoginResponseOffline,
	) => {
		if ("profileObj" in response) {
			const requestData = {
				profileObj: response.profileObj,
				email: response.profileObj.email,
				password: "",
				snsId: response.googleId,
				// 서버에서 구글 ID 토큰을 검증함
				tokenId: response.tokenId,
				loginType: "google",
			};
			dispatch(
				login({
					requestData,
					callback: () => history.push("/"),
					enqueueSnackbar,
				}),
			);
		}
	};

	return (
		<div
			style={{
				border: "1px solid #ccc",
				padding: "2.5rem",
				borderRadius: "10px",
			}}
		>
			<SignInInputBox />
			<div className="submitContainer">
				<Divider className="divide" />
				<Typography className="line">Or</Typography>
				<Divider className="divide" />
			</div>

			<GoogleLogin
				clientId="988201923898-booh6va8o883ic02hltjrauqic5chf5f.apps.googleusercontent.com"
				buttonText={t("login.sign_in_google")}
				onSuccess={responseGoogle}
				onFailure={responseGoogle}
				cookiePolicy="single_host_origin"
				render={(renderProps) => (
					<Button
						className="googleButton"
						variant="outlined"
						fullWidth={true}
						sx={{
							color: "inherit",
							borderColor: "inherit",
							height: "3.5rem",
							marginBottom: "2rem",
						}}
						startIcon={<img src={GoogleLogo} alt="사진없음" />}
						onClick={renderProps.onClick}
					>
						{t("login.sign_in_google")}
					</Button>
				)}
			/>
			<Link to="/auth/forgot" style={{ color: "#0071E3" }}>
				{t("login.password_recovery")}
			</Link>
		</div>
	);
}
